import Reservation from "../../components/Reservation"

export default function index() {
  return (
    <div>
      <Reservation />
    </div>
  )
}
